import styled from '@emotion/styled'

export const Wrapper = styled.div`
  padding-top: 5px;
`
